// Employees
export { default as Employees } from "./Employees";
export type { default as EmployeesProps } from "./EmployeesProps.interface";

// Employee
export { default as Employee } from "./components/Employee/Employee";
export type { default as EmployeeProps } from "./components/Employee/EmployeeProps.interface";